import { render } from "./comparison-table-visitors.view.vue?vue&type=template&id=c8d3a5a6&scoped=true&ts=true"
import script from "./comparison-table-visitors.view.vue?vue&type=script&lang=ts"
export * from "./comparison-table-visitors.view.vue?vue&type=script&lang=ts"

import "./comparison-table-visitors.view.vue?vue&type=style&index=0&id=c8d3a5a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d3a5a6"]])

export default __exports__